import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

const PageSkeleton = () => {
  return (
    <div>
      <Typography variant="h4">
        <Skeleton animation="wave" width={"70%"} />
      </Typography>
      <Typography variant="h5">
        <Skeleton animation="wave" width={"40%"} />
      </Typography>
      <Box py={2} ></Box>
      <Skeleton animation="wave" variant="rectangular" width="100%">
        <div style={{ paddingTop: "37%" }} />
      </Skeleton>
    </div>
  );
};

export default PageSkeleton;
